/**
 * Língua da interface em React: a app web e a extensão põem a língua da pessoa num
 * LocaleProvider; os componentes leem-na com useLocale() e escolhem as frases.
 */
import { DEFAULT_LOCALE, type Locale } from '@nolens/i18n';
import { createContext, useContext, type ReactNode } from 'react';

const LocaleContext = createContext<Locale>(DEFAULT_LOCALE);

export function LocaleProvider({ locale, children }: { locale: Locale; children: ReactNode }) {
  return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>;
}

export const useLocale = (): Locale => useContext(LocaleContext);
